module.exports = __webpack_public_path__ + "img/success3.ade65843.png";